import styled from 'styled-components'

import { Section as GSSection, Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, space } = theme

export const Section = styled(GSSection)`
  padding-bottom: 0;

  @media (${media.tablet}) {
    padding-bottom: ${space['spacing-xl']};
  }

  @media (${media.desktop}) {
    padding-bottom: 7.5rem;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
`

export const Infos = styled(GSInfos)`
  margin-bottom: ${space['spacing-xxxl']};

  p:last-child {
    margin-bottom: 0;
  }

  @media (${media.desktop}) {
    margin-bottom: 0;
  }
`
